import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Capacitor } from '@capacitor/core';
import { CapacitorPasskey } from '@capgo/capacitor-passkey';

import { AppModule } from './app/app.module';

// Object.defineProperty(navigator, 'onLine', {
//   get: () => false,
//   configurable: true, // Allows you to redefine or delete it later if needed
// });

// // 2. Dispatch the event after a tiny delay to ensure Angular/Capacitor listeners are ready
// setTimeout(() => {
//   window.dispatchEvent(new Event('offline'));
// }, 100);

async function bootstrap() {
  // Only needed inside the native app
  if (Capacitor.isNativePlatform()) {
    await CapacitorPasskey.autoShimWebAuthn();
  }

  await platformBrowserDynamic().bootstrapModule(AppModule);
}

bootstrap().catch(console.error);
